/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ScheduleMedicationInfusionsAliases {
  AUTOCOMPLETE_REASON = 'autocomplete-reason',
  BUTTON_SCHEDULE = 'button-schedule',
  CHECKBOX_SAVE_DEFAULT_TIMES = 'checkbox-save-default-times',
  CHECKBOX_SCHEDULE = 'checkbox-schedule',
  CONTAINER_PANEL_BUTTON_CONFIRMATION = 'container-panel-button-confirmation',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  FETCH_REASON = 'fetch-reason',
  FIELD_DESIRED_TIME = 'field-desired-time',
  FIELD_JUSTIFICATION = 'field-justification',
  FIELD_REASON = 'field-reason',
  FIELD_SAVE_DEFAULT_TIMES = 'field-save-default-times',
  FIELD_SCHEDULE_PREVIOUS = 'field-schedule-previous',
  FIELD_STANDARD_TIME_SLOTS = 'field-standard-time-slots',
  FORM_SCHEDULE = 'form-schedule',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_DESIRED_TIME = 'input-desired-time',
  INPUT_STANDARD_TIME_SLOTS = 'input-standard-time-slots',
  LAYOUT_SCHADULE = 'layout-schadule',
  MAPPER_REASON = 'mapper-reason',
  MEDICATION_HEADER_FRAGMENT = 'medication-header-fragment',
  PANEL_0 = 'panel-0',
  PANEL_BUTTON_CONFIRMATION = 'panel-button-confirmation',
  TEXT_AREA_JUSTIFICATION = 'text-area-justification',
  TEXT_REASON = 'text-reason',
}
export { ScheduleMedicationInfusionsAliases };
